import React, { useEffect } from "react";
import Attributes from "./Attributes";
import Variants from "./Variants";
import { useDispatch, useSelector } from "react-redux";
import { resetFormState } from "../../../../slices/common/reducer";
import { changeActiveTabs } from "../../../../slices/product/productSlice";
import Details from "./Details";
import { useParams } from "react-router-dom";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import { Card, CardHeader } from "reactstrap";
import SelectedTab from "../../../../Components/Common/Tabs/SelectedTabs/SelectedTab";
import Benefits from "./Benefits";
import Oem from "./Oem";
import OemBenefits from "./OemBenefits";

const SelectedProduct = () => {
  const dispatch = useDispatch();
  const tabs = useSelector((state) => state.product.selectedProduct.tab);
  const tabsEdit = useSelector((state) => state.product.selectedProduct.tabEdit);
  const activeTab = useSelector(
    (state) => state.product.selectedProduct.activeTabs
  );
  const data = useSelector(
    (state) => state.product.selectedProduct.detailsData
  );
  const params = useParams();
  const editMode = !!params.id;

  useEffect(() => {
    dispatch(resetFormState());
    dispatch(changeActiveTabs("details"));
  }, [dispatch]);
  const breadcrumbItems = editMode
    ? [
        { title: "Prod", link: "" },
        { title: "Product", link: "/prod/product" },
        { title: `${data.code}`, link: "/prod/product/update" },
      ]
    : [
        { title: "Prod", link: "" },
        { title: "Product", link: "/prod/product" },
        { title: "New Product", link: "/prod/product/create" },
      ];


      const selectedTabs = editMode ? tabsEdit : tabs;

  return (
    <div>
      <>
        <div className="page-content">
          <BreadCrumb items={breadcrumbItems} />
          <Card className="details-wrapper">
            <CardHeader>
              <SelectedTab
                tabs={selectedTabs}
                activeTab={activeTab}
                changeActiveTab={changeActiveTabs}
              />
            </CardHeader>
            {/* <CardBody> */}
            {/* <div className="selected-tab-bottom-content"> */}
            {activeTab === "details" && <Details />}
            {editMode && activeTab === "oem" && <Oem />}
            {/* Additional tabs conditionally rendered */}
            {editMode && activeTab === "benefits" && <Benefits />}
            {editMode && activeTab === "oem-benefits" && <OemBenefits />}
            {/* </div> */}
            {/* </CardBody> */}
          </Card>
        </div>
      </>
    </div>
  );
};

export default SelectedProduct;
